import {
  determineFullTradeData,
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
  returnRPLegFromThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";
import { statusFromAwarded } from "../colDefs/colDefsShared";

export function returnUnwindValueToRender(
  params: any,
  thisTrade: ExecutionStrategy,
) {
  if (!thisTrade) {
    return;
  }
  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);

  const helperObject = {
    params,
    thisTrade,
    isOp,
    isER,
    isOutright,
    isLeg,
  };

  const thisOPLeg = returnOPLegFormThisTrade(helperObject);

  const thisRPLeg = returnRPLegFromThisTrade(helperObject);

  if (isOp) {
    //ER
    // No Return
    if (isLeg || isOutright) {
      return thisOPLeg?.unwind;
    }
  } else {
    //RP
    //ER
    if (isLeg || isOutright) {
      if (
        thisTrade &&
        thisTrade.status &&
        !statusFromAwarded.includes(thisTrade.status)
      ) {
        if (thisRPLeg?.unwind == "Recoupon") {
          return ""; // Remove the recoupon value until a trade reaches awarded otherwise the RP knows the block will be recouponed.
        }
      }
      return thisRPLeg?.unwind;
    }
  }
  return params.data.unwind;
}

const UnwindTypeCellRenderer = (params: any) => {
  const fullTradeData = determineFullTradeData(params);
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;
  if (!thisTrade) return null;

  const valueToRender = returnUnwindValueToRender(params, thisTrade);

  return <div>{valueToRender}</div>;
};

export default UnwindTypeCellRenderer;
